export class CardInfo {
  // for credit card
  public cardType: string = 'VISA';
  public cardPresent: boolean = true;
  public cvn: string;
  public cardHolderName: string;
  public number: string;
  public expMonth: number;
  public expYear: number;

  // for debit/credit track data
  public value: string;
  public version: Version = Version.VERSION1;
  public pinBlock: string;
  public entryMethod: EntryMethod = EntryMethod.Manual;

  // for gift track data
  public pin: string = '';
  public trackData: string = '';
  public alias: string = '';
  public token: string = '';

  // PaymentMethodType
  public paymentMethodType: PaymentMethodType;
}

export enum Version {
  VERSION1 = 1,
  VERSION2 = 2,
}

export enum EntryMethod {
  Manual = 0,
  Swipe = 1,
  Proximity = 2,
}

export enum PaymentMethodType {
  Reference = 0,
  Credit = 2,
  Debit = 4,
  EBT = 8,
  Cash = 16,
  ACH = 32,
  Gift = 64,
  Recurring = 128,
  Other = 256,
  AltPayment = 512,
}

export enum PaymentSource {
  ApplePay = 1,
  GooglePay = 2,
}

export class BillingAddress {
  public streetAddres1: string = '';
  public streetAddres2: string = '';
  public streetAddres3: string = '';

  public city: string = '';
  public province: string = '';
  public state: string = '';

  public postalCode: string = '';
  public country: string = '';
  public countryCode: string = '';
}

export enum RecurringSequence {
  First = 0,
  Subsequent = 1,
  Last = 2,
}

export enum InquiryType {
  FOODSTAMP = 0,
  CASH = 1,
}

export enum TransactionSource {
  Merchant = '1',
  Checkout = '2',
  Mobile = '3',
  Online = '4',
  VirtualSell = '8',
}

export enum SourceComponent {
  ManualInvoice = '1',
  WorkOrder = '2',
  PaymentForms = '3',
  AddCustomerCard = '4',
  Subscription = '5',
  RecurringPayment = '6',
  QuickPaymentLink = '7',
  VirtualSell = '8',
  "Verifone-VS" = '10',
  "Verifone-MI" = '11',
  "iOS VS" = '12',
  "iOS MI" = '13',
  "Android VS" = '14',
  "Android MI" = '15'
}

export enum CheckType {
  PERSONAL = 0,
  BUSINESS = 1,
  PAYROLL = 2,
}

export enum AccountType {
  CHECKING = 0,
  SAVINGS = 1,
}
